<template>
    <div class="group-members-page">
        <group-page-header title="All Members">
            <span slot="additionalButtons" v-if="viewer_state.is_admin">
                <toggle-edit-mode-button v-model="editMode"></toggle-edit-mode-button>
            </span>
        </group-page-header>
        <div class="">
            <span class="group-page-header" v-if="admins.length">Group Admins
                <i
                        v-if="viewer_state.is_admin&&editMode"
                        class="fa fa-pencil pointer"
                        @click="manageAdmins"
                        @keydown.enter="manageAdmins"
                        aria-label="Manage Admins"
                        tabindex="0"
                        role="button"
                        v-tooltip="'Manage Admins'"
                ></i>
            </span>
        </div>
        <div v-if="admins.length" class="group-members-page__members-container">
            <a :href="admin.link"
               class="hvr-float-shadow margin-30-bottom"
               v-for="admin of admins"
               :key="admin.id"
            >
                <vue-stuff-preview

                        stuff-type="user"
                        :stuff-item="admin"
                        :online-mark="admin.online"
                        :animation="false"
                        :size="swamItemSize"
                        :margin="0"
                ></vue-stuff-preview>
            </a>
            <div
                    :style="swamFakeIconStyle"
                    v-for="fakeItem in swamGetFakeItems(admins.length)"
                    :key="fakeItem.id"
            ></div>
        </div>
        <div v-if="initialized&&!allAdminsLoaded" class="text-center">
            <span
                    class="pointer group-members-page__load-more-button"
                    @click="loadMoreAdmins"
                    @keydown.enter="loadMoreAdmins"
                    tabindex="0"
                    aria-label="Load More"
                    role="button"
            >Load {{
                    this.totalAdminsCount - this.admins.length
                }} more</span>
        </div>
        <div class="">
            <span class="group-page-header" v-if="members.length">Group Members
                <!--                <i-->
                <!--                        v-if="viewer_state.is_admin"-->
                <!--                        class="fa fa-pencil pointer"-->
                <!--                        @click="editMode=!editMode"-->
                <!--                        @keydown.enter="editMode=!editMode"-->
                <!--                        aria-label="Manage Members"-->
                <!--                        tabindex="0"-->
                <!--                        role="button"-->
                <!--                        v-tooltip="'Manage Members'"-->
                <!--                ></i>-->
            </span>
        </div>
        <div v-if="members.length" class="group-members-page__members-container">
            <a :href="member.link"
               class="hvr-float-shadow margin-30-bottom"
               v-for="member of members"
               :key="member.id"
            >
                <vue-stuff-preview
                        stuff-type="user"
                        :stuff-item="member"
                        :online-mark="member.online"
                        :animation="false"
                        :size="swamItemSize"
                        :deletable="editMode"
                        @delete="deleteMember(member)"
                        :margin="0"
                ></vue-stuff-preview>
            </a>
            <div
                    :style="swamFakeIconStyle"
                    v-for="fakeItem in swamGetFakeItems(members.length)"
                    :key="fakeItem.id"
            ></div>
        </div>
        <div v-infinite-scroll="loadMore"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {DjangoUrls} from 'DjangoUrls';
    import {mapGetters} from "vuex";
    import InfiniteScrollMixin from "../../../vue/mixins/InfiniteScrollMixin";
    import GroupResource from "../groups/group_resource";
    import {simplePopupFactory} from "shared/simple_popups/simplePopupFactory";
    import SelfWidthAwareMixin from "../../../vue/mixins/SelfWidthAwareMixin";
    import selectFactory from "shared/select_factory/select_factory";
    import GroupPageHeader from "./common/GroupPageHeader";
    import ToggleEditModeButton from "./common/ToggleEditModeButton";
    import {CurrentUserClass} from "shared/CurrentUser";

    export default {
        name: "GroupPageMembers",
        components: {ToggleEditModeButton, GroupPageHeader},
        mixins: [InfiniteScrollMixin, SelfWidthAwareMixin],
        data() {
            return {
                limit: 24,

                getResultsOnMount: false,
                admins: [],
                totalAdminsCount: 0,
                allAdminsLoaded: false,

                editMode: false,
            };
        },
        computed: {
            ...mapGetters('groupPage', {group: 'group', viewer_state: 'viewer_state'}),
            members() {
                return this.results;
            },
            swamItemSize() {
                return this.swamRecommendedItemSize;
            },
            swamMinItemSize() {
                let MIN_SIZE = 100;
                if (this.elWidth > 400) {
                    MIN_SIZE = 110;
                }
                if (this.elWidth > 610) {
                    MIN_SIZE = 123;
                }
                return MIN_SIZE;
            },
            swamMargin() {
                return 10;
            },
        },
        methods: {
            getListEndpoint() {
                const $http = Vue.getAngularModule('$http');
                return GroupResource($http).get_members_infinite_scroll;
            },
            getListEndpointArgs() {
                return [this.group.id];
            },
            getAdmins() {
                const $http = Vue.getAngularModule('$http');
                return GroupResource($http).get_admins_infinite_scroll(this.group.id, {
                    limit: this.limit,
                    offset: this.admins.length,
                    query: this.query
                })
                    .then(resp => {
                        this.admins = this.admins.concat(resp.data.results);
                        this.totalAdminsCount = resp.data.count;
                        this.allAdminsLoaded = (this.admins.length >= this.totalAdminsCount) || (resp.data.admins.length === 0);
                    });
            },
            loadMoreAdmins() {
                this.getAdmins();
            },
            deleteMember(member) {
                const $http = Vue.getAngularModule('$http');
                const $rootScope = Vue.getAngularModule('$rootScope');
                simplePopupFactory.show_popup(
                    'Delete Member',
                    `Are you sure you want to delete user '<strong>${member.name}</strong>' from this Group?`,
                    'Delete',
                    'Cancel',
                    'btn-red'
                )
                    .then(() => {
                        $rootScope.show_dimmer();
                        return GroupResource($http).delete_member(this.group.id, member.id);
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        Vue.notifications.success('Deleted');
                        this.results.splice(this.results.indexOf(member), 1);
                        this.totalCount -= 1;
                    }, err => Vue.notifications.error(err || 'Error'))
                    .finally($rootScope.hide_dimmer);
            },
            manageAdmins() {
                const $http = Vue.getAngularModule('$http');
                const $rootScope = Vue.getAngularModule('$rootScope');
                let selfDeletion = false;
                selectFactory()
                    .endpoint_selector(DjangoUrls["api.v1:group-get-admins-for-manage"](this.group.id), true, {
                        header: 'Manage Admins',
                        info: 'Select or de-select user from list to make them admins',
                        button_yes: 'Save',
                        button_no: 'Cancel',
                        empty: 'You do not have any users to select'
                    })
                    .then(res => {
                        let new_checked_ids = res[0];
                        let new_unchecked_ids = res[1];
                        if (new_unchecked_ids.includes(new CurrentUserClass().id)) {
                            selfDeletion = true;
                        }
                        $rootScope.show_dimmer();
                        return GroupResource($http).update_admins(this.group.id, new_checked_ids, new_unchecked_ids);
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        Vue.notifications.success('Updated');
                        this.allAdminsLoaded = false;
                        this.totalAdminsCount = undefined;
                        this.admins = [];
                        this.resetResults();
                        this.loadMembers();
                        if(selfDeletion){
                            this.$store.dispatch('groupPage/loadInfoAndViewerState');
                        }
                    }, err => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                    });
            },
            loadMembers() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                Promise.all([this.getAdmins(), this.getResults()])
                    .then(resp => {

                    }, err => {

                    })
                    .finally($rootScope.hide_dimmer);
            },
        },
        mounted() {
            this.loadMembers();
        }

    };
</script>

<style lang="scss" scoped>
  @import "commonStyle";

  .group-members-page {
    &__load-more-button {
      font-size: 18px;
      line-height: 18px;

      &:hover, &:focus {
        text-decoration: underline;
      }
    }

    &__members-container {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: flex-start;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
</style>